import Vue from 'vue';
import Vuex from 'vuex';
import api from '@/api/Search.js';
import groupApi from '@/api/GroupData';
import getSpecificUser from '@/api/UserData';
import sendCallback from '@/api/Callback';
import createCase from '@/api/CreateCase';
import survey from '@/api/Survey';
import faq from '@/api/Faq';
import config from '@/api/config.js'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    getSearchResult: [],
    getGroupMembers: [],
    getAllGroups: [],
    getSpecificUser: [],
    showAgentCard: false,
    clickedUserSearchResult: String,
    getCat: Object,
    getCatFromName: Object,
    goBack: false,
    restartScreen: false,
    surveyAnswers: [],
    surveyType: {}
  },
  mutations: {
    getCatFromName(state, getCatFromName) {
      state.getCatFromName = getCatFromName;
    },
    getCat(state, getCat) {
      state.getCat = getCat;
    },
    getSearchResult(state, getSearchResult) {
      state.getSearchResult = getSearchResult;
    },
    getGroupMembers(state, getGroupMembers) {
      state.getGroupMembers = getGroupMembers;
    },
    getAllGroups(state, getAllGroups) {
      state.getAllGroups = getAllGroups;
    },
    getSpecificUser(state, getSpecificUser) {
      state.getSpecificUser = getSpecificUser;
    },
    clickedUserSearchResult(state, clickedUserSearchResult) {
      state.clickedUserSearchResult = clickedUserSearchResult;
    },
    goBack(state, goBack) {
      state.goBack = goBack;
    },
    restartScreen(state,screenRestart) {
      state.restartScreen = screenRestart;
    },
    setSurveyValue(state, surveyAnswers) {
      state.surveyAnswers.push(surveyAnswers)
    },
    removeSurveyValue(state,QuestionsID) { 
      state.surveyAnswers = state.surveyAnswers.filter(function( obj ) {
        return obj.questionId !== QuestionsID;
      });
    },
    emptySurveyAnswers(state) { 
      state.surveyAnswers = [];
    },
    setSurveyType(state,surveyType) {
      state.surveyType = surveyType;
    }
  },
  actions: {
    restartScreenSharing({commit}) {
      if(this.state.restartScreen == false) {
        
        commit('restartScreen',true);
      } else {
        commit('restartScreen',false);
      }
    },
    goBack({commit}) {
      if(this.state.goBack == false) {
        commit('goBack',true);
      } else {
        commit('goBack',false);
      }
      
    },
    
    async checkIfUserIsInThisView({dispatch},userId) {
      userId = parseInt(userId);

      let allGroups = [];
      const groups = await dispatch('getAllGroups');

      for (let index = 0; index < groups.length; index++) {
          const element = groups[index];
          const data = await dispatch('getGroupMembers', element.id);
          allGroups.push({groupName: element.id, users: data.users});  

      }
      let allUsersInGroup = [];
      let allUsers;
      for (let index = 0; index < allGroups.length; index++) {
          const elements = allGroups[index];

              elements.users.forEach(element => {
              if(userId == element.userId) {
                  allUsers = elements.groupName;
              }

          });

      }

      return allUsers;
    },
 
    // ** Survey ** 
    deleteSurveyAnswer({ commit },questionId) { 
      commit('removeSurveyValue',questionId);
    },
    setSurvey({ commit },payload) {
      if(payload.type !== 'checkbox') {
        commit('removeSurveyValue',payload.questionId); // Check if any answer exists with same questionID
      }
      commit('setSurveyValue',payload); // Add new answer  
    },
    triggSurvey({commit},payload) {
      const isSurveyAnswered = localStorage.getItem('__surveyAnsw');
      if(payload.type === 'pre' && isSurveyAnswered == null) {
        payload.surveyId= config.customer.survey.preSurvey.surveyId;
      } 
      if(payload.type === 'post') {
        console.log("config",config.customer.survey)
        payload.surveyId= config.customer.survey.postSurvey.surveyId;
      } 
      
      commit('setSurveyType',payload)
    },
    saveSurvey({ commit },payload) {
      return new Promise((resolve,reject) => {
        survey.setSurvey(payload).then(response => {
          commit('emptySurveyAnswers');
          resolve(response);
        }).catch(error => {
          console.error("Could not save survey",error);
          reject(error);
        });
      });
    },
    getSurvey({},payload) {
      return new Promise((resolve,reject) => {
        survey.getSurvey(payload).then(response => {
          response.sort((a, b) => parseFloat(a.question.OrderQuestions) - parseFloat(b.question.OrderQuestions)); // Order by ascending
          resolve(response);
        }).catch(error => {
          console.log("Could not retrieve survey ",error);
          reject(error);
        });
      });
    },
    // ** Survey end **
    getCatFromName({ commit },payload) {
      return new Promise((resolve) => {
        faq.getCatFromName(payload).then(response => {
          commit('getCatFromName', response);
          resolve(response);
        });
      });
    },
  
    getCat({ commit }) {
      return new Promise((resolve, ) => {
        faq.getCat().then(response => {
          commit('getCat', response);
          resolve(response);
        });
      });
    },

    clickedUserSearchResult({ commit },payload) {
      commit('clickedUserSearchResult', payload)
      return "ok";
    
    },

    getSearchResult({ commit },payload) {
      return new Promise((resolve, ) => {
        api.getSearchResult(payload).then(response => {
          commit('getSearchResult', response);
          resolve(response);
        });
      });
    },
    getGroupMembers({ commit },payload) {
      return new Promise((resolve, ) => {
        groupApi.getGroupMembers(payload).then(response => {
          commit('getGroupMembers', response);
          resolve(response);
        });
      });
    },
    getAllGroups({ commit }) {
      return new Promise((resolve, ) => {
        groupApi.getAllGroups().then(response => {
          commit('getAllGroups', response);
          resolve(response);
        });
      });
    },
    getSpecificUser({ commit }, payload) {
      return new Promise((resolve, reject) => {
        getSpecificUser.getSpecificUser(payload).then(response => {
          commit('getSpecificUser', response);
          resolve(response);
        }).catch(err => {
          reject(err);
        });
        
      });
    },
    sendCallback({ }, payload) {
        sendCallback.sendCallback(payload).then(response => {
          console.log(response)
        }).catch(err => {
          console.log(err);
        });
    },
    submitCase({ }, payload) {
      createCase.submitCase(payload).then(response => {
        console.log(response);
      }).catch(err => {
        console.log(err);
      });
  },
  
    
  }
})
